import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import defaultsDeep from "lodash/defaultsDeep.js";
import DistanceFrom from 'distance-from';
import { action, entries, makeObservable, observable, override } from 'mobx';
import FieldFilter from "./FieldFilter.js";
var distanceFormatDefaults = {
  labels: {
    mi: 'mi',
    km: 'km',
    m: 'm',
    ft: 'ft'
  },
  collapseUnit: true,
  trailingZero: true,
  space: true
};
export function formatDistance(distance, unitOpts) {
  var opts = defaultsDeep({}, distanceFormatDefaults, unitOpts === false ? {
    labels: false,
    collapseUnit: false
  } : unitOpts ? unitOpts : {});
  if (opts.collapseUnit && !opts.labels) {
    console.warn('using collapseUnit with labels disabled can lead to confusing results');
  }
  var value = distance.distance;
  var unit = distance.unit;
  if (opts.collapseUnit) {
    if (unit === 'km' && value < 0.1) {
      // 0.1km is < 100m
      value = value * 1000;
      unit = 'm';
    } else if (unit === 'mi' && value < 0.1) {
      value = value * 5280;
      unit = 'ft';
    }
  }
  var parts = [String((Math.round(value * 10) / 10).toFixed(opts.trailingZero ? 1 : 0))];
  if (opts.space) parts.push(' ');
  if (opts.labels) parts.push(opts.labels[unit]);
  return parts.join('');
}
export class DistanceFilter extends FieldFilter {
  static createComparator(fieldName) {
    return (results, store) => results.sort((a, b) => {
      var _a$fields$fieldName$d, _a$fields$fieldName, _b$fields$fieldName$d, _b$fields$fieldName;
      var aScore = (_a$fields$fieldName$d = (_a$fields$fieldName = a.fields[fieldName]) === null || _a$fields$fieldName === void 0 ? void 0 : _a$fields$fieldName.distance) !== null && _a$fields$fieldName$d !== void 0 ? _a$fields$fieldName$d : 0;
      var bScore = (_b$fields$fieldName$d = (_b$fields$fieldName = b.fields[fieldName]) === null || _b$fields$fieldName === void 0 ? void 0 : _b$fields$fieldName.distance) !== null && _b$fields$fieldName$d !== void 0 ? _b$fields$fieldName$d : 0;
      return aScore == bScore ? 0 : aScore < bScore ? -1 : 1;
    });
  }
  constructor(fieldName, params) {
    var _params$initialState, _params$matchOnEmpty, _params$allowChangeUn, _params$initialRadius, _params$initialUnit;
    super(fieldName, _objectSpread({
      initialState: (_params$initialState = params.initialState) !== null && _params$initialState !== void 0 ? _params$initialState : null,
      matchOnEmpty: (_params$matchOnEmpty = params.matchOnEmpty) !== null && _params$matchOnEmpty !== void 0 ? _params$matchOnEmpty : true
    }, params));
    _defineProperty(this, "allowChangeUnits", void 0);
    _defineProperty(this, "initialUnit", void 0);
    _defineProperty(this, "initialRadius", void 0);
    this.allowChangeUnits = (_params$allowChangeUn = params.allowChangeUnits) !== null && _params$allowChangeUn !== void 0 ? _params$allowChangeUn : false;
    this.initialRadius = (_params$initialRadius = params.initialRadius) !== null && _params$initialRadius !== void 0 ? _params$initialRadius : 50;
    this.initialUnit = (_params$initialUnit = params.initialUnit) !== null && _params$initialUnit !== void 0 ? _params$initialUnit : 'mi';
    makeObservable(this, {
      allowChangeUnits: observable,
      initialRadius: observable,
      initialUnit: observable,
      setState: override,
      updateResults: action,
      applySnapshot: override
    });
  }
  init(store) {
    super.init(store);
    store.hooks.afterResultsUpdate.add(() => this.updateResults());
  }
  setState(value) {
    super.setState(value);
    this.updateResults();
  }
  updateResults() {
    for (var [id, result] of entries(this.store.results)) {
      if (this.state) {
        result.fields[this.fieldName] = {
          unit: this.state.unit,
          distance: DistanceFrom([this.state.origin.lat, this.state.origin.lng]).to([result.lat, result.lng]).in(this.state.unit)
        };
      } else {
        result.fields[this.fieldName] = undefined;
      }
    }
  }
  exposeParams() {
    return _objectSpread(_objectSpread({}, super.exposeParams()), {}, {
      allowChangeUnits: this.allowChangeUnits,
      initialRadius: this.initialRadius,
      initialUnit: this.initialUnit
    });
  }
  createSnapshot() {
    var deproxyify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return _objectSpread(_objectSpread({}, super.createSnapshot(deproxyify)), {}, {
      allowChangeUnits: this.allowChangeUnits,
      initialRadius: this.initialRadius,
      initialUnit: this.initialUnit
    });
  }
  applySnapshot(snapshot) {
    super.applySnapshot(snapshot);
    this.allowChangeUnits = this.allowChangeUnits;
    this.initialRadius = this.initialRadius;
    this.initialUnit = this.initialUnit;
    this.updateResults();
  }
  get isEmpty() {
    return this.state === null;
  }
  test(location) {
    if (this.matchOnEmpty && this.isEmpty) return true;else if (!this.state) return false;else return location.fields[this.fieldName].distance <= this.state.radius;
  }
}
export default DistanceFilter;
//# sourceMappingURL=DistanceFilter.js.map